export default "__VITE_ASSET__C9OC0XdX__"